import React from 'react';
import DropdownMechanism from '../../../GeneralComponents/DropdownMechanism';
import api from '../../../../services/apiService';
import {
    MyTableCell1
} from "../../../../styling/Styles";
import { findIndexIfArgExists } from '../../../../validations/validations';

//  This component renders the cell of the row that is responsible for user's state info
const StatusCell = ({ row, index, status, setStatus, showStatus, activeProjects, setActiveProjects}) => {
        
    const informState = (option) => {
        setStatus(option);

        let tempActiveProjects = activeProjects;
        const indexArg = findIndexIfArgExists(row._id, activeProjects);

        if(  indexArg === -1 ){
            tempActiveProjects = [...tempActiveProjects, row._id];
        }
        else{
            tempActiveProjects = tempActiveProjects.filter( (project, indexProj) => indexProj !== indexArg)
        }
        setActiveProjects(tempActiveProjects);

        const tempProjectId = row._id
        api.updateProject2(tempProjectId, {status: option.toUpperCase()})
    }

    return(
        <MyTableCell1
            align="center"
            style={
                index % 2 === 0
                ? null
                : { backgroundColor: "#CFD8E0" }
            }
            >
                { showStatus === true ?
                    <DropdownMechanism
                        target = {status}
                        targets = { ['active', 'suspended']}
                        selectTarget ={informState}
                    />
                    :
                    <span style={{color: '#999999'}}>{status}</span>
                }     
        </MyTableCell1>
    )
}

export default StatusCell;